import React, { Component } from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import Lottie from "lottie-react";
import { Link } from 'react-router-dom'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { Modal, ModalHeader, ModalBody, Button, ModalFooter } from 'reactstrap';
import { Container, Row, Col, ListGroup, Dropdown } from 'react-bootstrap';
import back from '../../assets/img/icons/back.svg'
import slider1 from '../../assets/img/sections/slider1.jpg'
import slider2 from '../../assets/img/sections/slider2.jpg'
import locations from '../../assets/img/people/location.svg'
import work from '../../assets/img/people/work.svg'
import educations from '../../assets/img/people/education.svg'
import more from '../../assets/img/icons/more.svg'
import heartmatch from '../../assets/img/people/heartmatch.svg'
import dislike from '../../assets/img/people/dislike.svg'
import secondsuperlike from '../../assets/img/people/secondsuperlike.svg'
import like from '../../assets/img/people/like.svg'
import undo from '../../assets/img/people/undo.svg'
import seconddislike from '../../assets/img/people/seconddislike.svg'
import dislikejson from '../../assets/json/dislike.json'
import likejson from '../../assets/json/likejson.json'
import SuperLikePlan from '../commoncomponents/superlikeplan';
import booster from '../../assets/img/people/booster.svg'
import reset from '../../assets/img/icons/reset_icon_large.png'
import boost from '../../assets/img/boost.svg'
import filter from '../../assets/img/people/filter.svg'
import Filter from '../commoncomponents/filter';
import BoostPlan from '../commoncomponents/boostplan';
import BoostActivate from '../commoncomponents/boostactivate';
import BoostPaymentPlan from '../commoncomponents/boostpaymentplan';
import Join from './plan/join';
import ls from "local-storage";
import axios from 'axios';
import PaymentPending from '../main/plan/paymentpending';
import revert from '../../assets/img/revert.svg';
import { Trans } from "react-i18next";   
import "../../config/i18n";
import { withTranslation } from "react-i18next";

class Find extends Component {
    constructor(props) {
        super(props);
        this.SetReport = this.SetReport.bind(this);
        this.toggleDisLikeLottie = this.toggleDisLikeLottie.bind(this);
        this.handleRewind = this.handleRewind.bind(this);
        this.resetusers = this.resetusers.bind(this);
        this.state = {
            currentSlideIndex: 0,
            showDisLikeLottie: false,
            showLikeLottie: false,
            superlikeplanmodal: false,
            filtermodal: false,
            premiummodal: false,
            boostplanmodal: false,
            boostactivatemodal: false,
            boostpaymentplanmodal: false,
            langKey: ls.get('LangValue'),
            api_url:localStorage.getItem('api_url'),
            user_details: '',
            peopleDetails: '',
            property: '',
            imagess: [],
            interests: [],
            languages: [],
            report: '',
            matches: '',
            paymentpendingmodal: false,
            activatedBoostModel: false,
            images_count: '',
            resetplanmodal: false,
            reset_count: '',
            nofoundmodal: false,
            reset_msg: '',
        };
    }

    componentDidMount() {

        if (this.props.i18n.language === 'ar' || this.props.i18n.language === 'he') {
            document.body.dir = 'rtl';
            document.body.classList.add('rtl');
            document.body.classList.remove('ltr')
        } else {
            document.body.dir = 'ltr';
            document.body.classList.remove('rtl');
            document.body.classList.add('ltr');
        }

        localStorage.setItem('filter_page','2');

        let data = new FormData();
        data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));  
        data.append('language', this.state.langKey);
        axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
        axios({
            method: 'post',
            url: this.state.api_url+'webprofile',
            data: data, 
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if(res.data.status !== false) {
                const user_details = res.data.result;
                this.setState({ reset_count: user_details.totalresets });
                var profile = new FormData();
                profile.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
                profile.append('language', this.state.langKey);
                axios({
                    method: 'post',
                    url: this.state.api_url + 'webcheckboost',
                    data: profile,
                    headers: {'Content-Type': 'multipart/form-data'}
                }).then(res => {
                    if (res.data.status === "true") {
                        this.setState({
                            boost_cashpayment: res.data.boost_cashpayment,
                            boostStatus: 'activated',
                            boostCount: res.data.boost_count
                        });
                    } else {
                        this.setState({
                            boost_cashpayment: res.data.boost_cashpayment,
                            boostStatus: 'available',
                            boostCount: res.data.boost_count
                        });
                    }
                });

                this.setState({
                    user_details: user_details,
                });

                var date = new Date();
                var details = new FormData();
                details.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
                details.append('language', this.state.langKey);                
                details.append('timestamp', date.getTime());
                axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
                axios({
                    method: 'post',
                    url: this.state.api_url+'webgetpeople',
                    data: details,
                    config: { headers: {'Content-Type': 'multipart/form-data' }}
                }).then(res => {
                    if(res.data.status === "false"){
                        this.props.history.push("/nofind");
                    } else {
                        const dataa = res.data;
                        console.log("/find: ", dataa);
                        this.setState({
                            peoples: dataa.peoples,
                            property: dataa.peoples[0],
                            imagess: dataa.peoples[0].imagess,
                            interests: dataa.peoples[0].interest,
                            languages: dataa.peoples[0].language,
                            images_count: dataa.peoples[0].imagess.length
                        });
                        if(dataa.peoples[0].report === "false") {
                            this.setState({ report: "Report User"})
                        } else {
                            this.setState({ report: "Undo Report User"})
                        }
                    }
                }).catch(error => {
                    this.props.history.push("/"); 
                });
            } else {
                this.props.history.push("/");  
            }
        }).catch(error => {
           this.props.history.push("/"); 
        });
    }

    handleSlideChange = index => {
        this.setState({ currentSlideIndex: index });
    };

    toggleDisLikeLottie = (user_id) => {
        console.log("ID: ", user_id);
        var match = new FormData();
        match.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
        match.append('follow_id', user_id);
        match.append('language', this.state.langKey);
        axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
        axios({
            method: 'post',
            url: this.state.api_url+'webunmatch',
            data: match,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if(res.data.status !== "false") {
                this.setState(prevState => ({
                    showDisLikeLottie: !prevState.showDisLikeLottie
                }));
                var date = new Date();
                var details = new FormData();
                details.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
                details.append('timestamp', date.getTime());
                details.append('language', this.state.langKey);
                axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
                axios({
                    method: 'post',
                    url: this.state.api_url+'webgetpeople',
                    data: details,
                    config: { headers: {'Content-Type': 'multipart/form-data' }}
                }).then(res => {
                    window.location.reload();
                }).catch(error => {
                    this.props.history.push("/"); 
                });
            }
        }).catch(error => {
           this.props.history.push("/"); 
        });
    }

    toggleLikeLottie = (user_id, reqType) => {
        var match = new FormData();
        match.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
        match.append('follow_id', user_id);
        match.append('type', reqType);  
        match.append('language', this.state.langKey);
        axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
        axios({
            method: 'post',
            url: this.state.api_url+'webmatch',
            data: match,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if(res.data.status === "true") {
                this.setState(prevState => ({
                    showLikeLottie: !prevState.showLikeLottie
                }));
                this.setState({
                    matches: ''   
                });
                if(res.data.match === "1") {
                    this.setState({ 
                        matches: res.data.result   
                    });      
                    this.setState({ send_message: true });      
                }
                var date = new Date();
                var details = new FormData();
                details.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
                details.append('timestamp', date.getTime());
                details.append('language', this.state.langKey);
                axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
                axios({
                    method: 'post',
                    url: this.state.api_url+'webgetpeople',
                    data: details,
                    config: { headers: {'Content-Type': 'multipart/form-data' }}
                }).then(res => {
                    if(this.state.matches === '') {
                        window.location.reload();
                    }
                }).catch(error => {
                    this.props.history.push("/"); 
                });
            } else if(res.data.superlike_cashpayment === '1') {
                this.handlePaymentPendingOpenModal();
            } else {
                if(reqType === "superlike" && res.data.superlike_count === "0") {
                    this.handleSuperLikePlanOpenModal();
                }
            }
        });
    }

    handleSuperLikePlanOpenModal = () => {
        this.setState({ superlikeplanmodal: true });
    }

    handleSuperLikePlanCloseModal = () => {
        this.setState({ superlikeplanmodal: false });
    }

    handleFilterOpenModal = () => {
        localStorage.setItem('seleted_filterreligion', "");
        localStorage.setItem('selected_filterlanguage', "");    
        this.setState({ filtermodal: true });
    }

    handleFilterCloseModal = () => {
        this.setState({ filtermodal: false });
        localStorage.removeItem('seleted_filterreligion');
    }

    handlePremiumOpenModal = () => {
        this.setState({ premiummodal: true });
    }

    handlePremiumCloseModal = () => {
        this.setState({ premiummodal: false });
    }

    handleBoostPlanOpenModal = () => {
        if(this.state.boost_cashpayment === '1') {
            this.handlePaymentPendingOpenModal();
        } else if(this.state.boostStatus === 'activated') {
            this.setState({ activatedBoostModel: true });
        } else if(this.state.user_details.boost_count > 0 && this.state.boostStatus === 'available') {
            this.handleBoostActivateOpenModal();
        } else if(this.state.user_details.boost_count === 0 && this.state.boostStatus === 'activated') {
            this.handleBoostActivateOpenModal();
        } else if(this.state.user_details.boost_count > 0 && this.state.boostStatus === 'activated') {
            this.handleBoostActivateOpenModal();
        } else {
            this.setState({ boostplanmodal: true });
        }   
    }

    handleBoostPlanCloseModal = () => {
        this.setState({ boostplanmodal: false });
    }

    handleBoostActivateOpenModal = () => {
        this.setState({ boostactivatemodal: true });
    }

    handleBoostActivateCloseModal = () => {
        this.setState({ boostactivatemodal: false });
    }

    handleBoostPaymentPlanCloseModal = () => {
        this.setState({ boostpaymentplanmodal: false });
    }

    handleBoostPaymentPlanOpenModal = () => {
        this.setState({ boostpaymentplanmodal: true });
    }

    SetReport(e) {
        var report = new FormData();
        report.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
        report.append('report_user_id',this.state.property.user_id);
        report.append('language', this.state.langKey);
        axios({
            method: 'post',
            url: this.state.api_url+'webreport',
            data: report,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if(res.data.status !== "false") {
                if(this.state.report === "Report User") {
                    this.setState({ 
                        report: "Undo Report User",
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    this.setState({ 
                        report: "Report User",
                    });
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                }
            }
        }).catch(error => { 
            this.props.history.push("/"); 
        });
    }

    handleRewind(e) {
        if(this.state.user_details.premium_member !== '' && this.state.user_details.premium_member === 'true') {
            var match = new FormData();
            match.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
            match.append('language', this.state.langKey);
            axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
            axios({
                method: 'post',
                url: this.state.api_url+'webundomatch',
                data: match,
                config: { headers: {'Content-Type': 'multipart/form-data' }}
            }).then(res => {
                if(res.data.status !== false) {
                    var date = new Date();
                    var details = new FormData();
                    details.append('user_id', JSON.parse(localStorage.getItem('session_userid')));
                    details.append('timestamp', date.getTime());
                    details.append('language', this.state.langKey);
                    axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
                    axios({
                        method: 'post',
                        url: this.state.api_url+'webgetpeople',
                        data: details,
                        config: { headers: {'Content-Type': 'multipart/form-data' }}
                    }).then(res => {
                        window.location.reload();
                    }).catch(error => {
                        this.props.history.push("/"); 
                    });
                }
            }).catch(error => { 
                this.props.history.push("/"); 
            });
        } else {
            this.handlePremiumOpenModal();
        }
    }

    closeModal(tabId) {
        this.setState({
            [tabId]: false
        });
        window.location.reload();
    }

    shutModal(tabId) {
        this.setState({
            [tabId]: false
        });
    }

    Message(frienduser_id) { 
        var report = new FormData();
        report.append('sender_id', JSON.parse(localStorage.getItem('session_userid')));
        report.append('receiver_id',frienduser_id); 
        report.append('language', this.state.langKey); 
        axios.defaults.headers.common['Authorization'] = JSON.parse(localStorage.getItem('session_token'));
        axios({
            method: 'post',
            url: this.state.api_url+'webcreatchat',
            data: report,
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            const chatid = res.data.chatid;
            const friendid = frienduser_id;
            this.props.history.push(`/message/${friendid}/${chatid}`) 
        })
    }

    handlePaymentPendingOpenModal = () => {
        this.setState({ paymentpendingmodal: true });
    }

    handlePaymentPendingCloseModal = () => {
        this.setState({ paymentpendingmodal: false });
    }

    resetusers(){
        let errors = {};
        var payment = new FormData();
        payment.set('user_id', JSON.parse(localStorage.getItem('session_userid')));
        axios({
          method: 'post', 
          url: this.state.api_url+'resetusers',
          data: payment, 
          config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            if (res.data.status === "true") {
                this.setState({
                    nofoundmodal: true,
                    reset_msg: 'Reset done successfully'
                });
                window.location.reload();
            }else{
                this.setState({
                    nofoundmodal: true,
                    reset_msg: 'No dislike users found'
                });
            }
        });
    }

    handleResetPlanOpenModal = () => {
        if(this.state.reset_count !== '' && this.state.reset_count !== null && this.state.reset_count === 0) {
            this.setState({
                nofoundmodal: true,
                reset_msg: 'You have completed all your reset count'
            });
        } else {
            this.setState({ resetplanmodal: true });
        }
    }

    render() { 
        const { showDisLikeLottie, showLikeLottie, user_details } = this.state;
        const { user_name, location, religion, company, bio, user_id, age, job, school } = this.state.property;
        const settings = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            afterChange: this.handleSlideChange,
            arrows: this.state.images_count === 1 ? false : true
        };
        const { t } = this.props;
        return (
            <>
                <section className='common_layout overlow_x'>
                    <div>
                        <div className='header_layout'>
                            <div className='header_img'>
                                <img src={booster} alt="img" onClick={this.handleBoostPlanOpenModal} />
                                {this.state.user_details.premium_member === 'true' && this.state.user_details.plan_type !== "Kaba Silver" && (
                                    <img src={revert} alt="img" onClick={this.handleResetPlanOpenModal} className='revert_image' />
                                )}
                            </div>
                            <div className='header_title'>
                                <h4><Trans i18nKey="Find New People">Find New People</Trans></h4>
                            </div>
                            <div className='header_img' onClick={this.handleFilterOpenModal}>
                                <img src={filter} alt="img" className='filter_img'/>
                            </div>
                        </div>
                        {this.state.successMessage && (
                            <div className='whole_information'>
                                <div className={this.state.suc_cls}>
                                    {this.state.successMessage}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='mt_1'>
                        <Container>
                            <div className='detail_card'>
                                <Container>
                                    <Row>
                                        <Col md={7}>
                                            <Slider {...settings}>
                                                {
                                                    this.state.imagess.map((image) => (
                                                        <div>
                                                            <div className='slider_img'>
                                                                <img src={image} alt="img" />
                                                                <div className='dislikes_lottie'>
                                                                    {showDisLikeLottie ? <Lottie animationData={dislikejson} className='dislikes_lottieplayer' /> : null}
                                                                </div>
                                                                <div className='likes_lottie'>
                                                                    {showLikeLottie ? <Lottie animationData={likejson} className='likes_lottieplayer' /> : null}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                }
                                            </Slider>
                                        </Col>
                                        <Col md={5}>
                                            <div className='slider_content'>
                                                <div>
                                                    <div className='slider_wholeH'>
                                                        <div className='slider_title_head'>
                                                            {(age!=='' && age!==null) 
                                                            ? (<h4 className='slider_title'>{user_name}, {age}</h4>) 
                                                            : (<h4 className='slider_title'>{user_name}</h4>)}
                                                            <div className='more'>
                                                                <Dropdown>
                                                                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                                                                        <img src={more} alt="img" />
                                                                    </Dropdown.Toggle>
                                                                    <Dropdown.Menu>
                                                                        <Dropdown.Item onClick={this.SetReport}>{t(this.state.report)}</Dropdown.Item>
                                                                    </Dropdown.Menu>
                                                                </Dropdown>

                                                            </div>
                                                        </div>
                                                        <div className='slider_subdetails_div'>
                                                            {
                                                                (location !== '' && location !== null) ? (
                                                                    <div className='slider_subdetails'>
                                                                        <img src={locations} alt="img" />
                                                                        <p>{location}</p>
                                                                    </div>
                                                                )
                                                                : ''
                                                            }
                                                            {
                                                                (school !== '' && school !== null) ? (
                                                                    <div className='slider_subdetails'>
                                                                        <img src={educations} alt="img" />
                                                                        <p>{school}</p>
                                                                    </div>
                                                                )
                                                                : ''
                                                            }
                                                            {
                                                                (job !== '' && job !== null) ? (
                                                                    <div className='slider_subdetails'>
                                                                        <img src={educations} alt="img" />
                                                                        <p>{job}</p>
                                                                    </div>
                                                                )
                                                                : ''
                                                            }
                                                            {
                                                                (company !== '' && company !== null) ? (
                                                                    <div className='slider_subdetails'>
                                                                        <img src={work} alt="img" />
                                                                        <p>{company}</p>
                                                                    </div>
                                                                )
                                                                : ''
                                                            }
                                                        </div>
                                                        <div className='slider_subtitle'>
                                                            <h4><Trans i18nKey="Religion">Religion</Trans> :</h4>
                                                            <p>{religion}</p>
                                                        </div>
                                                        <div className='slider_subtitle'>
                                                            <h4><Trans i18nKey="Biography">Biography</Trans> :</h4>
                                                            <p>{bio}</p>
                                                        </div>
                                                        <div className='slider_subtitle'>
                                                            <h4><Trans i18nKey="Language">Language</Trans> :</h4>
                                                            <p>{this.state.languages.join(', ')}</p>
                                                        </div>
                                                        <div className='slider_subtitle'>
                                                            <h4><Trans i18nKey="Interests">Interests</Trans> :</h4>
                                                            <div className='slider_list'>
                                                                <div className='sliderlist_height'>
                                                                    <ListGroup>
                                                                        {this.state.interests && this.state.interests.map((each_interest, index) => (
                                                                            <ListGroup.Item key={index}>
                                                                                {each_interest}
                                                                            </ListGroup.Item>
                                                                        ))}
                                                                    </ListGroup>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='people_likes'>
                                                        <img src={undo} alt='img' title="Rewind" className='peoplelike_img' onClick={this.handleRewind} />
                                                        <img src={secondsuperlike} alt='img' title="Superlike" className='peoplesuperlike_img' onClick={() => this.toggleLikeLottie(user_id, 'superlike')} />
                                                        <img src={like} alt='img' title="Like" className='peoplesuperlike_img' onClick={() => this.toggleLikeLottie(user_id, 'like')} />
                                                        <img src={seconddislike} alt='img' title="Dislike" className='peoplelike_img' onClick={() => this.toggleDisLikeLottie(user_id)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </Container>
                    </div>
                </section>

                <Modal isOpen={this.state.send_message} toggle={this.closeModal.bind(this, 'send_message')} className="modal_div matchmodal" centered>
                    <ModalHeader toggle={this.closeModal.bind(this, 'send_message')}></ModalHeader>
                    <ModalBody>
                        <div>
                            <div className='matchmodal_img'>
                                <div className='matchmodal_div'>
                                    <img src={this.state.matches.loguser_image} alt='img' />
                                </div>
                                <div className='matchcenter'>
                                    <img src={heartmatch} alt='img' />
                                </div>
                                <div className='matchmodal_div'>
                                    <img src={this.state.matches.frienduser_image} alt='img' />
                                </div>
                            </div>
                            <div className='matchmodal_section'>
                                <h4><Trans i18nKey="It's Match!">It's Match!</Trans></h4>
                                <p><Trans i18nKey="You and">You and</Trans> {this.state.matches.frienduser_name} <Trans i18nKey="Like Each Other!">Like Each Other!</Trans></p>
                            </div>
                            <div className='matchmodalbtn'>
                                <Button onClick={this.Message.bind(this, this.state.matches.frienduser_id)}><Trans i18nKey="Send message">Send message</Trans></Button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
                
                <Modal isOpen={this.state.resetplanmodal} toggle={this.shutModal.bind(this, 'resetplanmodal')} className="modal_div boostplan_modal" centered>
                    <ModalBody className="religion_modal">
                        <div className='boostplan_img'>
                            <img src={boost} alt="img" />
                        </div>
                        <div className='boostplan_content'>
                            <h4>{this.state.reset_count} <Trans i18nKey="Remaining">Remaining</Trans></h4>
                            <p><Trans i18nKey="Rewind and Revisit profiles you've swiped left on. Never miss a chance at a connection again.">Rewind and Revisit profiles you've swiped left on. Never miss a chance at a connection again.</Trans></p>
                        </div>
                    </ModalBody>
                    <ModalFooter className="forgot_button_plr boostplan_button">
                        <Button className='boostplan_cancelbtn' onClick={this.shutModal.bind(this, 'resetplanmodal')}>
                        <Trans i18nKey="CANCEL">CANCEL</Trans>
                        </Button>
                        <Button className='button_primary ' onClick={this.resetusers}>
                        <Trans i18nKey="Reset Users">Reset Users</Trans>
                        </Button>
                    </ModalFooter>
                </Modal>
                
                <Modal isOpen={this.state.nofoundmodal} toggle={this.shutModal.bind(this, 'nofoundmodal')} className="modal_div joinplan_modal" >
                    <ModalBody className="religion_modal paymentsuccess_modal">
                        <div className=''>
                            <p>{this.state.reset_msg}</p>
                        </div>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.activatedBoostModel} toggle={this.shutModal.bind(this, 'activatedBoostModel')} className="modal_div joinplan_modal" >
                    <ModalBody className="religion_modal paymentsuccess_modal">
                        <div className=''>
                            <p><Trans i18nKey="Boost Activated Currently">Boost Activated Currently</Trans></p>
                        </div>
                    </ModalBody>
                </Modal>

                <SuperLikePlan
                    showModal={this.state.superlikeplanmodal}
                    handleClose={this.handleSuperLikePlanCloseModal}
                />

                <Filter
                    showModal={this.state.filtermodal}
                    handleClose={this.handleFilterCloseModal}
                />

                <Join
                    showModal={this.state.premiummodal}
                    handleClose={this.handlePremiumCloseModal}
                />

                <BoostPlan
                    showModal={this.state.boostplanmodal}
                    handleClose={this.handleBoostPlanCloseModal}
                />

                <BoostActivate
                    showModal={this.state.boostactivatemodal}
                    handleClose={this.handleBoostActivateCloseModal}
                />

                <BoostPaymentPlan
                    showModal={this.state.boostpaymentplanmodal}
                    handleClose={this.handleBoostPaymentPlanCloseModal}
                />

                <PaymentPending
                    showModal={this.state.paymentpendingmodal}
                    handleClose={this.handlePaymentPendingCloseModal}
                />
            </>
        );
    }
}

export default withTranslation("translations")(withRouter(Find));
